import React from 'react';
// @ts-ignore
import {
	useLazyMonitoringCentreCasesQuery,
	useLazyNurseCasesQuery,
	useTermItemsQuery,
} from '../../../../graphql/graphql';
import useFlatData from '../../../Base/Hooks/useFlatData';
import useCases from '../../../Case/Hooks/useCases';
import MonitoringCenterSolvedRequestsFilter from './MonitoringCenterSolvedRequestsFilter';
import MonitoringCenterList from '../MonitoringCenterList/MonitoringCenterList';
import MonitoringCenterSolvedRequestsItem from './MonitoringCenterSolvedRequestsItem';
import MonitoringCenterListHeader from '../MonitoringCenterList/MonitoringCenterListHeader';

const headerColumns: string[] = [
	'component.monitoringCenter.tableHead.number',
	'component.monitoringCenter.tableHead.requestType',
	'component.monitoringCenter.tableHead.patient',
	'component.monitoringCenter.tableHead.birthNumber',
	'component.monitoringCenter.tableHead.attendingDoctor',
	'component.monitoringCenter.tableHead.closedBy',
	'component.monitoringCenter.tableHead.workplace',
	'component.monitoringCenter.tableHead.diagnosis',
	'component.monitoringCenter.tableHead.closedWith',
	'component.monitoringCenter.tableHead.created',
	'component.monitoringCenter.tableHead.closed',
];

import useSocket from '../../../Base/Hooks/useSocket';
import { Socket } from '../../../Base/Enums/Socket.enum';

const MonitoringCenterSolvedRequests: React.FC = () => {
	const [getWorkplaceCasesQuery, { data, isLoading }] =
		useLazyMonitoringCentreCasesQuery();
	const { getWorkplaceCases, getNextPage, page, setPage } = useCases(
		getWorkplaceCasesQuery,
		40,
	);
	const {
		flatData,
		hasMoreData,
		loadData,
		setFilter,
		isLoading: isFlatDataLoading,
	} = useFlatData(
		getWorkplaceCases,
		{
			data: data?.monitoringCentreCases?.data,
			totalPages: data?.monitoringCentreCases?.meta?.totalPages,
			page: data?.monitoringCentreCases?.meta?.page,
		},
		page,
		setPage,
		{ solved: true },
	);

	useSocket(Socket.CASE_TAKEN, loadData);

	return (
		<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<MonitoringCenterSolvedRequestsFilter onFilter={setFilter} />
			<MonitoringCenterList
				flatData={flatData}
				onLoadMore={getNextPage}
				onRefresh={loadData}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				isFlatDataLoading={isFlatDataLoading}
				renderItem={item => <MonitoringCenterSolvedRequestsItem item={item} />}
				customHeader={
					<MonitoringCenterListHeader customColumns={headerColumns} />
				}
			/>
		</div>
	);
};

export default MonitoringCenterSolvedRequests;
